import RentalServices from './RentalServices.yaml?component';

export { RentalServices };
